<template>
  <section class="backoffice-login-stage">
    <template-recovery>
      <template #banner>
        <img
          src="~@/assets/images/banners/password.svg"
          alt="Esqueci minha senha"
        />
      </template>
      <template #contentHeader>
        <h2>{{ $t('senha-redefinicao.titulo') }}</h2>
        <h3>
          {{ $t('senha-redefinicao.subtitulo') }}
        </h3>
      </template>
      <template #content>
        <div class="reset-password">
          <form class="form-template">
            <b-field
              :label="labelRegistro"
              :type="{ 'is-danger': errors.has('registro') }"
              :message="errors.first('registro')"
            >
              <b-input
                v-model.lazy="registro"
                name="registro"
                v-validate="'required'"
                :data-vv-as="$t('campos_validacao.registro')"
                :placeholder="commonPlaceholder"
                @input="setRegistro"
              />
            </b-field>
            <div class="link-reset">
              &nbsp;
            </div>
            <b-field
              :label="labelNovaSenha"
              :type="{ 'is-danger': errors.has('novasenha') }"
              :message="errors.first('novasenha')"
              class="password-field"
            >
              <b-input
                v-model.lazy="novaSenha"
                name="novasenha"
                type="password"
                v-validate="'required'"
                :data-vv-as="$t('campos_validacao.nova_senha')"
                :placeholder="commonPlaceholder"
                password-reveal
                @input="verificadorPoliticas.validar(novaSenha)"
              />
            </b-field>
            <div>
              <!-- -->
              <senha-politicas
                v-model="verificadorPoliticas.politicas"
                v-if="verificadorPoliticas !== null"
              />
              <!-- -->
            </div>
            <b-field
              :label="labelConfirmaSenha"
              :type="{ 'is-danger': errors.has('confirma_senha') }"
              :message="errors.first('confirma_senha')"
              class="password-field"
            >
              <b-input
                v-model.lazy="confirmaNovaSenha"
                name="confirma_senha"
                v-validate="'required'"
                type="password"
                :placeholder="commonPlaceholder"
                :data-vv-as="$t('campos_validacao.confirma_senha')"
                password-reveal
              />
            </b-field>
            <div class="link-reset">
              &nbsp;
            </div>
            <div class="link-reset">
              &nbsp;
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <button
                    :disabled="!disabledButton"
                    class="button button-primary"
                    type="submit"
                    @click.prevent="mudarSenha"
                  >
                    {{ $t('botoes.redefinir') }}
                  </button>
                </div>
              </div>
            </div>
          </form>
          <modal-template v-if="showModal" class="override-modal">
            <template #header>
              <h2>{{ modalInfo.titulo }}</h2>
            </template>
            <template #body>
              <pre class="pre-mensagens">{{ modalInfo.subtitulo }}</pre>
            </template>
            <template #footer>
              <button
                id="loginmodal"
                class="button button-primary"
                @click="modalInfo.acaoBotao"
              >
                {{ modalInfo.btnTexto }}
              </button>
            </template>
          </modal-template>
        </div>
      </template>
    </template-recovery>
  </section>
</template>

<script>
import authService from '@/services/auth-service'
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import TemplateRecovery from '@/components/recovery/TemplateRecovery'
import { mapActions } from 'vuex'
import SenhaPoliticas from '../../components/personal-data/Senha/SenhaPoliticas'
import { VerificadorSenha } from '../../mixins/verificador-senha'

export default {
  name: 'RedefinirSenha',

  components: {
    ModalTemplate,
    TemplateRecovery,
    SenhaPoliticas
  },

  data() {
    return {
      showModal: false,
      registro: '',
      novaSenha: '',
      confirmaNovaSenha: '',
      labelRegistro: this.$t('login.label-register'),
      labelNovaSenha: this.$t('labels.senha_nova'),
      labelConfirmaSenha: this.$t('labels.senha_confirmacao'),
      commonPlaceholder: this.$t('placeholders.common'),
      code: this.$route.query['CODE'] || this.$route.query['code'] || this.$route.query['Code'],
      letraUnidade: this.$route.query['u'] || this.$route.query['U'],
      verificadorPoliticas: null,
      modalInfo: {
        titulo: '',
        subtitulo: '',
        btnTexto: '',
        acaoBotao: this.toggleInfoModal
      }
    }
  },
  beforeMount() {
    if (this.letraUnidade !== undefined) {
      authService.codigoValido(this.code, this.letraUnidade).then((res) => {
        if (!res.ok) {
          this.mostrarModal(
            this.$t('erro.link-senha.titulo'),
            this.$t('erro.link-senha.subtitulo'),
            this.$t('botoes.voltar'),
            () => {
              this.$router.push('/')
            }
          )
        }
      })
    }
    this.verificadorPoliticas = new VerificadorSenha(this.novaSenha, this.registro, ' ', {
      mensagens: {
        tamanhoMinimo: this.$t('validacao_senha.tamanho_minimo'),
        contem_numero: this.$t('validacao_senha.contem_numero'),
        contem_minuscula: this.$t('validacao_senha.contem_minuscula'),
        contem_maiuscula: this.$t('validacao_senha.contem_maiuscula'),
        nao_contem_sequencias: this.$t('validacao_senha.nao_contem_sequencias'),
        nao_contem_prontuario: this.$t('validacao_senha.nao_contem_prontuario'),
        nao_contem_data_nascimento: this.$t(
          'validacao_senha.nao_contem_data_nascimento'
        )
      }
    })
  },
  computed: {
    disabledButton() {
      return this.registro && this.novaSenha && this.confirmaNovaSenha
    }
  },

  methods: {
    ...mapActions(['redefinirSenha', 'auth']),
    toggleInfoModal() {
      this.showModal = !this.showModal
    },

    setRegistro(value) {
      this.verificadorPoliticas.registro = value
    },

    mostrarModal(titulo, subtitulo, textoBotao, acaoBotao) {
      this.modalInfo = {
        titulo: titulo,
        subtitulo: subtitulo,
        btnTexto: textoBotao,
        acaoBotao: acaoBotao
      }
      this.showModal = !this.showModal
    },
    errorText() {
      this.mostrarModal(
        this.$t('erro.padrao.titulo'),
        this.$t('erro.padrao.subtitulo'),
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },
    okTexto() {
      this.mostrarModal(
        this.$t('senha-redefinicao.sucesso.titulo'),
        this.$t('senha-redefinicao.sucesso.subtitulo'),
        this.$t('botoes.entrar'),
        () => {
          this.$router.push('/')
        }
      )
    },
    senhaNaoConfere() {
      this.mostrarModal(
        this.$t('erro.senhas-nao-conferem.titulo'),
        this.$t('erro.senhas-nao-conferem.subtitulo'),
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },
    verificarPoliticaSenha() {
      if (this.novaSenha !== this.confirmaNovaSenha) {
        this.senhaNaoConfere()
        return false
      }

      this.verificadorPoliticas.registro = this.registro
      this.verificadorPoliticas.validar(this.novaSenha)

      if (!this.verificadorPoliticas.senhaValida) {
        var mensagens = this.verificadorPoliticas.mensagensErro().join('\r\n')

        this.mostrarModal(
          this.$t('erro.padrao.titulo'),
          mensagens,
          this.$t('botoes.confirmar'),
          this.toggleInfoModal
        )
      }

      return this.verificadorPoliticas.senhaValida
    },
    async mudarSenha() {
      if (this.verificarPoliticaSenha()) {
        await this.redefinirSenha({
          username: this.registro,
          password: this.novaSenha,
          code: this.code
        })
          .then(() => {
            this.okTexto()
          })
          .catch((erro) => {
            this.mostrarModal(
              this.$t('erro.padrao.titulo'),
              erro.detail,
              this.$t('botoes.confirmar'),
              this.toggleInfoModal
            )
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.button[type='submit'] {
  display: block;
  max-width: 100%;
  margin-top: 0;
  text-align: center;
}
i {
  font-style: normal;
}

.pre-mensagens {
  overflow-x: auto;
  white-space: pre-wrap;
}
</style>
